import { OFFLINE_FORMS_UPLOAD } from "@/graphql/offline-form-upload-query";
import { PEER_FLAG_APPLICANT_QUERY } from "@/graphql/peer-flag-applicant";
import { flagApplicantApi } from "@/providers/apis/peers-flag-applicant";
import {
  OfflineFormData,
  User,
  reviewerDataTable,
} from "@/models/common-interface/common.interface";
import {
  addInactive,
  filters,
  ReviewerInactiveApplicationInterface,
} from "@/models/reviewer-inactive-lists/reviewer-inactive-lists.interface";
import { getApplicationDetails } from "@/providers/apis/getApplictionDetails";
import { appConfigService } from "@/providers/services/app/app-config";
import { Component, Vue } from "vue-property-decorator";
import gql from "graphql-tag";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import moment from "moment";
import { utils } from "@/utils/utils";
import DateRangePicker from "@/components/date-range-picker-local/components/DateRangePicker.vue";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import {
  FilterStateStorageNames,
  SortingKeyName,
  SortingOrderKey,
  TableSortEvent,
} from "@/models/constants/filters.interface";

@Component({
  name: "reviewer-inactive-lists",
  components: {
    AppLoaderComponent,
    DateRangePicker,
    ErrorPopupComponent,
  },
})
export default class ReviewerInactiveLists extends Vue {
  public reviewerInactiveData: ReviewerInactiveApplicationInterface[] = [];
  public userDetails!: User;
  public offlineFormData: OfflineFormData[] = [];
  public isLoading!: boolean;
  public filterDetails: filters = {} as filters;
  public limit = 10;
  public offset = 0;
  public currentPage = 1;
  public totalItem = 0;
  public statusFilterData = "";
  public dateFilter = "";
  public opens = "right";
  public timePicker = false;
  public isDataEmpty = false;
  public errorMessage = "";
  public addApplication = false;
  public isFileValid = false;
  public checkValidation = false;
  public vaildFile = false;
  public isfileUploaded = true;
  public isSubmitted = false;
  public toogleStatus = false;
  public showDelete = appConfigService.getShowDelete();
  public deleteTargetId = "";
  public deleteEmail = "";
  public deleteFirstName = "";
  public deleteLastName = "";
  public deleteSubmittedAt = "";
  public deleteProgressStatus = "";
  public deleteSuccess = false;
  public openModal = false;
  public startDate: any;
  public endDate: any;
  public emailData: any = null;
  public file: any = null;
  public selected: any = [];
  public applyStatusFilter: any = [];
  public addNewCertificationForm: any = {
    applicationId: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    applicationDocument: [],
    employmentDocument: [],
    referenceOneDocument: [],
    referenceTwoDocument: [],
    referenceThreeDocument: [],
  };
  public dateRange = {
    startDate: "",
    endDate: "",
  };
  public localeDate = {
    format: "yyyy-m-dd",
    applyLabel: "Apply",
    cancelLabel: "Cancel",
    firstDay: 0,
  };
  public options = [
    { text: "Received", value: "RECEIVED" },
    { text: "Need More Info", value: "NEED MORE INFO" },
    { text: "Processing", value: "PROCESSING" },
    { text: "Accepted", value: "ACCEPTED" },
    { text: "Not Accepted", value: "NOT ACCEPTED" },
  ];
  public sort = SortingKeyName.updatedAt;
  public sortBy = SortingOrderKey.DESC;
  public tableFields = [
    {
      key: "submittedAt",
      label: "Submission Date",
      sortable: true,
      thClass: "application-date",
    },
    { key: "firstName", label: "Applicant First Name", sortable: true },
    { key: "lastName", label: "Applicant Last Name", sortable: true },

    {
      key: "email",
      label: "Email Address",
      sortable: true,
      thClass: "applicant-email pointer-events",
    },
    {
      key: "progressStatus",
      label: "Approval Status",
      sortable: true,
      thClass: "application-status",
      tdClass: "progress-status",
    },
    {
      key: "action",
      label: "Action",
      sortable: false,
      thClass: "application-action pointer-events",
      tdClass: "actions",
    },
  ];
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    telCharacter: this.telCharacterValidate,
  };
  public flagOptions: any[] = [];
  public flagDetailsCache: Record<string, any> = {};

  get popoverPlacement(): string {
    return window.innerWidth < 768 ? "top" : "left";
  }

  get popoverTrigger(): string {
    return window.innerWidth < 768 ? "click blur" : "hover";
  }

  public getFlagDetail(item: any): any {
    return this.flagDetailsCache[item.userId || item.email] || null;
  }

  public fetchFlagHistory(item: any) {
    const key = item.userId || item.email;
    if (this.flagDetailsCache[key]) return;
    const params = item.userId ? { id: item.userId } : { email: item.email };
    flagApplicantApi.getFlagHistory(params).then((res: any) => {
      const entries = Array.isArray(res) ? res : [];
      this.$set(this.flagDetailsCache, key, entries[0] || {});
    });
  }

  public formatFlagDate(date: string): string {
    return moment(date).format("MMM D, YYYY");
  }

  public getFlagLabels(flags: any[]): string {
    if (!flags || !flags.length) return "";
    return flags
      .map((f) => {
        const opt = this.flagOptions.find(
          (o) => o.item === f || o.item === Number(f)
        );
        return opt ? opt.name : f;
      })
      .join(", ");
  }

  public created() {
    const userDetails = localStorage.getItem("user_details");
    if (userDetails) {
      this.userDetails = JSON.parse(userDetails);
    }
    if (this.$route.query.status) {
      const status: string = this.$route.query.status as string;
      this.toogleStatus = !this.toogleStatus;
      this.selected = [status];
      this.onApplyFilter();
    } else {
      const inActiveFilter = localStorage.getItem(
        FilterStateStorageNames.INACTIVE
      )
        ? JSON.parse(
            localStorage.getItem(FilterStateStorageNames.INACTIVE) || ""
          )
        : null;
      if (inActiveFilter) {
        this.filterDetails = { ...this.filterDetails, ...inActiveFilter };
        this.selected = this.filterDetails.status
          ? typeof this.filterDetails.status == "string"
            ? this.filterDetails.status?.split(",")
            : this.filterDetails.status
          : [];
        this.toogleStatus = !this.toogleStatus;
        localStorage.removeItem(FilterStateStorageNames.INACTIVE);
      } else {
        this.selected = this.options
          ?.map((status) => {
            if (!["Not Accepted", "Accepted"]?.includes(status?.text)) {
              return status?.value;
            }
          })
          ?.filter((value) => value !== undefined);
        this.toogleStatus = !this.toogleStatus;
      }
      this.applyExistingFilters();
    }
    this.$apollo
      .query({
        query: gql`query ${OFFLINE_FORMS_UPLOAD}`,
      })
      .then((result) => {
        this.offlineFormData = result.data.offlineFormsUploads.data;
        this.offlineFormData = this.offlineFormData.filter(
          (data) => data.attributes.form_name === "certification"
        );
      });
    this.$apollo
      .query({ query: gql`query ${PEER_FLAG_APPLICANT_QUERY}` })
      .then((result) => {
        const inputs =
          result.data.peerFlagApplicant.data.attributes.form_fields.formInputs;
        this.flagOptions = inputs[0][0].propBind.options;
      });
  }

  public applyExistingFilters() {
    this.toogleStatus = !this.toogleStatus;
    this.applyStatusFilter = this.selected;
    this.statusFilterData = this.applyStatusFilter.join(",");
    this.limit = this.filterDetails.limit || this.limit;
    this.offset = this.filterDetails.offset || this.offset;
    this.currentPage = (this.offset + this.limit) / 10;
    if (this.filterDetails?.from && this.filterDetails?.to) {
      this.dateRange.startDate = this.filterDetails?.from.toString();
      this.dateRange.endDate = this.filterDetails.to.toString();
      this.startDate = moment(new Date(this.dateRange.startDate)).format(
        "MM-DD-YYYY"
      );
      this.endDate = moment(new Date(this.dateRange.endDate)).format(
        "MM-DD-YYYY"
      );
      this.dateFilter = this.startDate + " - " + this.endDate;
    }
    this.getReviewerInactiveLists();
  }

  public getReviewerInactiveLists() {
    this.isLoading = true;
    this.filterDetails.limit = this.limit;
    this.filterDetails.offset = this.offset;
    this.filterDetails.status = this.statusFilterData;
    this.filterDetails.from = this.startDate;
    this.filterDetails.to = this.endDate;
    this.filterDetails.sort = this.sort;
    this.filterDetails.sortBy = this.sortBy;
    getApplicationDetails
      .getInactiveApplicationList(this.filterDetails)
      .then((result) => {
        this.isLoading = false;
        this.reviewerInactiveData = result.list;
        this.totalItem = result.totalCount;
        if (this.reviewerInactiveData.length > 0) {
          this.isDataEmpty = false;
        } else {
          this.isDataEmpty = true;
        }
        this.reviewerInactiveData.forEach(
          (element: ReviewerInactiveApplicationInterface) => {
            element.submittedAt = moment(element.submittedAt).format(
              "MM-DD-YYYY"
            );
            element.completionStatus = {
              isApplicationFormReviewed:
                element.fillStatus === "COMPLETED" ? true : false,
              isEmploymentSummaryReviewed:
                element.summaryStatus === "COMPLETED" ? true : false,
              isReferenceFormReviewed:
                element.referralStatus === "COMPLETED" ? true : false,
            };
          }
        );
      })
      .catch((error) => {
        this.isDataEmpty = true;
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public closePopup() {
    this.$bvModal.hide("error-modal-center");
  }

  public addInactiveForm() {
    this.addApplication = true;
  }

  public applicationSubmit() {
    this.isFileValid = !this.isFileValid;
    this.checkValidation = true;
    this.$validator.validateAll().then((validate) => {
      if (validate && this.vaildFile && this.isfileUploaded) {
        this.checkValidation = false;
        //need to add API call
        this.addNewCertificationForm = {} as addInactive;
        this.isSubmitted = true;
      }
    });
  }

  public fileValid(event: any) {
    this.vaildFile = event;
  }

  public fileUploaded(event: boolean) {
    this.isfileUploaded = event;
  }

  public viewApplication() {
    this.$router.push({
      path: `#`,
      query: {
        formType: "offline",
      },
    });
  }
  public numberValidation(evt: Event, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public emptyEvent() {
    return;
  }

  public onClearFilter() {
    if (this.$route.query.status) {
      this.$router.replace("/reviewer-dashboard/inactive");
    }
    this.offset = 0;
    this.currentPage = 1;
    this.toogleStatus = !this.toogleStatus;
    this.selected = [];
    this.applyStatusFilter = [];
    this.isLoading = true;
    this.statusFilterData = "";
    this.getReviewerInactiveLists();
  }

  public onApplyFilter() {
    this.offset = 0;
    this.currentPage = 1;
    this.toogleStatus = !this.toogleStatus;
    this.applyStatusFilter = this.selected;
    this.statusFilterData = this.applyStatusFilter.join(", ");
    this.getReviewerInactiveLists();
  }

  public onClearStatusFilter(isDateFilter = false, index: any) {
    if (this.$route.query.status) {
      this.$router.replace("/reviewer-dashboard/inactive");
    }
    if (isDateFilter) {
      this.dateFilter = "";
      this.startDate = "";
      this.endDate = "";
      this.dateRange.startDate = "";
      this.dateRange.endDate = "";
    } else {
      this.applyStatusFilter.splice(index, 1);
      this.selected = this.applyStatusFilter;
      this.statusFilterData = this.applyStatusFilter;
    }
    this.offset = 0;
    this.currentPage = 1;
    this.getReviewerInactiveLists();
  }

  public onClearAllFilterStatus() {
    if (this.$route.query.status) {
      this.$router.replace("/reviewer-dashboard/inactive");
    }
    this.offset = 0;
    this.currentPage = 1;
    this.dateRange.startDate = "";
    this.dateRange.endDate = "";
    this.startDate = "";
    this.endDate = "";
    this.dateFilter = "";
    this.selected = [];
    this.applyStatusFilter = [];
    this.isLoading = true;
    this.statusFilterData = "";
    this.filterDetails.firstName = "";
    this.filterDetails.lastName = "";
    this.filterDetails.email = "";
    this.sort = SortingKeyName.updatedAt;
    this.sortBy = SortingOrderKey.DESC;
    this.getReviewerInactiveLists();
  }

  public onOpenModal(row: any) {
    this.emailData = row;
    this.$bvModal.show("email-modal");
  }

  public updated() {
    window.document.onclick = (event) => {
      if (this.toogleStatus) {
        const getFilterElement =
          document.getElementsByClassName("filter-status")[0];
        if (
          getFilterElement &&
          !getFilterElement.contains(event.target as Node)
        ) {
          this.toogleStatus = !this.toogleStatus;
        }
      }
    };
  }

  public loadContent(page: number) {
    this.currentPage = page;
    this.offset = (page - 1) * this.limit;
    this.getReviewerInactiveLists();
  }

  public sortChanged(event: TableSortEvent) {
    if (event) {
      this.offset = 0;
      this.currentPage = 1;
    }
    if (
      event.sortBy &&
      SortingKeyName[event.sortBy as keyof typeof SortingKeyName] !== undefined
    ) {
      this.sort = SortingKeyName[event.sortBy as keyof typeof SortingKeyName];
      this.sortBy = event?.sortDesc
        ? SortingOrderKey.DESC
        : SortingOrderKey.ASC;
    }
    this.getReviewerInactiveLists();
  }

  public emailSentStatus(event: boolean) {
    if (event) {
      this.$bvModal.hide("email-modal");
    }
  }

  public dateChip() {
    if (this.dateRange) {
      this.startDate = moment(new Date(this.dateRange.startDate)).format(
        "MM-DD-YYYY"
      );
      this.endDate = moment(new Date(this.dateRange.endDate)).format(
        "MM-DD-YYYY"
      );
    }
    this.offset = 0;
    this.currentPage = 1;
    this.dateFilter = this.startDate + " - " + this.endDate;
  }

  public mailPopup() {
    this.openModal = true;
  }

  public handleFileSelect(evt: any) {
    const files = evt.target.files; // FileList object
    this.file = files[0];
  }
  public getType(type: string) {
    if (type.includes("pdf") || type.includes("doc") || type.includes("docx")) {
      return "application";
    } else {
      return "image";
    }
  }

  public previewForm(row: any, event: any) {
    localStorage.setItem(
      FilterStateStorageNames.INACTIVE,
      JSON.stringify(this.filterDetails)
    );
    this.$router.push({
      path: `inactive/${row.item.id}`,
    });
  }

  public confirmDelete(row: any) {
    this.deleteTargetId = row.item.id;
    this.deleteEmail = row.item.email;
    this.deleteFirstName = row.item.firstName;
    this.deleteLastName = row.item.lastName;
    this.deleteSubmittedAt = row.item.submittedAt;
    this.deleteProgressStatus = row.item.progressStatus || "";
    this.$bvModal.show("delete-application-modal-inactive");
  }

  public cancelDelete() {
    this.$bvModal.hide("delete-application-modal-inactive");
  }

  public submitDelete() {
    this.isLoading = true;
    getApplicationDetails
      .deleteInactiveApplication(this.deleteTargetId)
      .then(() => {
        this.isLoading = false;
        this.deleteSuccess = true;
        setTimeout(() => {
          this.$bvModal.hide("delete-application-modal-inactive");
          this.deleteSuccess = false;
          this.getReviewerInactiveLists();
        }, 5000);
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public formTypeTableRowClass(item: reviewerDataTable, type: string) {
    return utils.formTypeTableRowClass(item, type);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }
}
